import React, { FC, ReactNode } from "react";
import * as styles from "./dialog.module.scss";
import { IconButton } from "@mui/material";
import { CloseIcon } from "../icons";

export interface DialogProps {
  open: boolean;
  onClose: () => void;
  children?: ReactNode;
  title?: string;
  description?: string;
  description2?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  showCloseButton?: boolean;
  closeOnBackdropClick?: boolean;
}

export const Dialog: FC<DialogProps> = ({
  open,
  onClose,
  children,
  showCloseButton = true,
  closeOnBackdropClick = true,
  title,
  description,
  description2,
  confirmButtonText,
  cancelButtonText,
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (closeOnBackdropClick && e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className={`${styles.dialogContainer} ${open && styles.dialogVisible}`}
      onClick={handleBackdropClick}
    >
      <div className={styles.dialogContent}>
        <div className={styles.dialogHeader}>
          <div className={styles.dialogHeaderContent}>
            {title && <h2 className={styles.dialogTitle}>{title}</h2>}
          </div>
          {showCloseButton && (
            <IconButton className={styles.closeBtn} onClick={onClose}>
              <CloseIcon className={styles.closeIcon} />
            </IconButton>
          )}
        </div>

        {(description || description2) && (
          <div className={styles.dialogDescriptionContainer}>
            {description && (
              <p className={styles.dialogDescription}>{description}</p>
            )}
            {description2 && (
              <p className={styles.dialogDescription}>{description2}</p>
            )}
          </div>
        )}

        {children && children}

        {(confirmButtonText || cancelButtonText) && (
          <div className={styles.dialogButtons}>
            {cancelButtonText && (
              <button
                className={styles.dialogCancelButton}
                onClick={() => {
                  if (onCancel) {
                    onCancel();
                  } else {
                    onClose();
                  }
                }}
              >
                {cancelButtonText}
              </button>
            )}
            {confirmButtonText && (
              <button
                className={styles.dialogConfirmButton}
                onClick={() => {
                  if (onConfirm) {
                    onConfirm();
                  }
                  onClose();
                }}
              >
                {confirmButtonText}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
